export default "__VITE_ASSET__b4130e5b__"